import {css} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import * as analytics from 'analytics/Analytics';
import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';
import CreateMenu from 'nav/navbar/CreateMenu';
import {makeNavbarBackgroundStyles} from 'nav/navbar/NavBarColor';
import {getTabStyles, navBarIconStyles} from 'nav/navbar/NavBarStyles';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import getTestProps from 'test/lib/cypress/getTestProps';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export interface CreateIconProps {
  isCreateMenuOpen: boolean;
}

export default function CreateIcon({isCreateMenuOpen}: CreateIconProps): JSX.Element {
  return (
    <Tooltip isDisabled={isCreateMenuOpen} placement={FloatingPlacement.RIGHT} text="Create">
      <div
        className={classNames(css(getTabStyles(isCreateMenuOpen)), isCreateMenuOpen && 'open')}
        style={makeNavbarBackgroundStyles()}
        {...getTestProps({
          component: 'CreateIcon',
          element: 'styleWrapper',
        })}
      >
        <CreateMenu
          isOpen={isCreateMenuOpen}
          onToggle={(newIsOpen) => {
            if (newIsOpen) {
              analytics.trackEvent({
                module: ANALYTICS_MODULE.NAVIGATION,
                action: 'opened_create_menu',
                actionCategory: ACTION_CATEGORY.READ,
              });
              SidepanelActions.openCreateMenu();
            } else {
              SidepanelActions.closeCreateMenu();
            }
          }}
        >
          <div
            className={classNames(css(navBarIconStyles.iconWrapper), 'CreateIcon-inner')}
            {...getTestProps({
              component: 'CreateIcon',
              element: 'inner',
            })}
            role="button"
            aria-label="Create"
            aria-haspopup="menu"
            tabIndex={0}
          >
            <div
              className={css(navBarIconStyles.inner)}
              {...getTestProps({
                component: 'CreateMenu',
                element: 'iconWrapper',
              })}
            >
              <BenchlingIcon icon="compose" className={css(navBarIconStyles.icon)} />
            </div>
          </div>
        </CreateMenu>
      </div>
    </Tooltip>
  );
}
